import { z } from 'zod';
import type { IdType } from '@/components/FilterChip/IdTypeFilterChip';
import { OrderDirection } from '@/constants/orderDirection';
export const ColumnKey = {
  TIMESTAMP: 'timestamp',
  WHO_ACCESSED: 'whoAccessed',
  IDENTITY: 'identity',
  DEVICE: 'device',
  DETECTION_TOOL: 'detectionTool',
  ACCESSED_TO: 'accessedTo',
  ACTION: 'action'
} as const;
export type ColumnKey = (typeof ColumnKey)[keyof typeof ColumnKey];
export const SortableColumnKey = {
  TIMESTAMP: ColumnKey.TIMESTAMP,
  WHO_ACCESSED: ColumnKey.WHO_ACCESSED,
  IDENTITY: ColumnKey.IDENTITY,
  ACCESSED_TO: ColumnKey.ACCESSED_TO,
  ACTION: ColumnKey.ACTION
} as const;
export type SortableColumnKey = (typeof SortableColumnKey)[keyof typeof SortableColumnKey];
const SortableColumnKeySchema = z.enum([SortableColumnKey.TIMESTAMP, SortableColumnKey.WHO_ACCESSED, SortableColumnKey.IDENTITY, SortableColumnKey.ACCESSED_TO, SortableColumnKey.ACTION]) satisfies z.ZodType<SortableColumnKey>;
const IdTypeSchema = z.enum(['PERSONAL_EMAIL', 'PERSONAL_MAIN_EMAIL', 'PERSONAL_SUB_EMAIL', 'PERSONAL_PHONE', 'PERSONAL_SNS_ID', 'WORKER_EMAIL', 'WORKER_MAIN_EMAIL', 'WORKER_SUB_EMAIL', 'WORKER_MAIN_PHONE', 'WORKER_SUB_PHONE', 'EMPLOYEE_NUMBER', 'EMPLOYEE_ID', 'EMPLOYEE_SUB_ID', 'MANUAL_ASSIGN']) satisfies z.ZodType<IdType>;
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  sortColumn: SortableColumnKeySchema.optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  visitUserIdIn: z.array(z.string()).optional(),
  idTypeIn: z.array(IdTypeSchema).optional()
});
export type SearchParams = z.infer<typeof SearchSchema>;